import script from "./SpendingPlanPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpendingPlanPage.vue?vue&type=script&setup=true&lang=ts"

import "./SpendingPlanPage.vue?vue&type=style&index=0&id=233efc10&scoped=true&lang=css"
import "./SpendingPlanPage.vue?vue&type=style&index=1&id=233efc10&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233efc10"]])

export default __exports__